import { formatPhDate, todayInPH } from '@/lib/phDate';
import type { ApplicationResponse } from '@/types/generated/openapi';

interface EditContext {
  isSupervisorOrAbove: boolean;
  /** farms.settings.members_edit_applications */
  membersEdit: boolean;
  /** Preparing or active crop; the flag does not reach closed crops. */
  cropOpen: boolean;
  userId: string | undefined;
}

/** Mirrors the API rule (ensure_can_edit_application); the server stays the authority. */
export function canEditApplication(ctx: EditContext, row: Pick<ApplicationResponse, 'technician_id' | 'created_at'>): boolean {
  if (ctx.isSupervisorOrAbove) return true;
  if (ctx.membersEdit && ctx.cropOpen) return true;
  return !!ctx.userId && row.technician_id === ctx.userId && formatPhDate(new Date(row.created_at)) === todayInPH();
}

// The entry screen creates a blank row and fills it in within moments, so a gap that short is
// the entry itself, not a correction.
const FILL_IN_GRACE_MS = 10 * 60_000;

export function wasEdited(row: Pick<ApplicationResponse, 'created_at' | 'last_modified'>): boolean {
  return new Date(row.last_modified).getTime() - new Date(row.created_at).getTime() > FILL_IN_GRACE_MS;
}
